import { z } from 'zod';

/** Unique UUID identifier of a Website Performance report. */
export const WebsitePerformanceReportIdSchema = z.string().uuid();
export type WebsitePerformanceReportId = z.infer<typeof WebsitePerformanceReportIdSchema>;
